import React from "react";
import PageHero from "../components/PageHero";

export function PrivacyPolicyPage() {
  return (
    <div data-testid="privacy-policy-page">
      <PageHero path="privacy.hero" kicker="Legal" title="Privacy Policy" />
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate space-y-5 text-slate-600 text-sm leading-relaxed">
          <p>Kiki Centre for Technology ("we", "our", "us") respects your privacy. This policy explains what information we collect and how we use it.</p>
          <h3 className="text-lg font-bold text-[#0B2A6B]">Information we collect</h3>
          <p>When you submit an enquiry, admission or contact form we collect your name, email, phone number and any details you choose to share. This is used solely to respond to your enquiry and provide information about our courses and admissions.</p>
          <h3 className="text-lg font-bold text-[#0B2A6B]">How we use your information</h3>
          <p>We use your details to contact you regarding admissions, courses, placements and events. We do not sell or share your personal data with third parties for marketing purposes.</p>
          <h3 className="text-lg font-bold text-[#0B2A6B]">Cookies & analytics</h3>
          <p>We may use cookies and analytics tools to understand how visitors use our website and to improve your experience.</p>
          <h3 className="text-lg font-bold text-[#0B2A6B]">Contact</h3>
          <p>For any privacy-related questions, email us at <a className="text-yellow-600" href="mailto:info@kikicentre.com">info@kikicentre.com</a> or call +91 8800288994.</p>
        </div>
      </section>
    </div>
  );
}

export function TrademarkNoticePage() {
  return (
    <div data-testid="trademark-notice-page">
      <PageHero path="trademark.hero" kicker="Legal" title="Trademark Notice" />
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-5 text-slate-600 text-sm leading-relaxed">
          <p>"Kiki Centre for Technology", the Kiki logo and related marks are trademarks of Kiki Centre for Technology. All other product names, logos and brands are property of their respective owners.</p>
          <p>All company, product and service names used on this website are for identification purposes only. Use of these names, trademarks and brands does not imply endorsement.</p>
          <p>The German Chamber of Skilled Crafts (HWK), Koblenz and partner company names and logos are the property of their respective owners and are used to indicate our training partnerships and certifications.</p>
          <p>For any trademark queries, contact <a className="text-yellow-600" href="mailto:info@kikicentre.com">info@kikicentre.com</a>.</p>
        </div>
      </section>
    </div>
  );
}
